import { render, staticRenderFns } from "./MajorDialog.vue?vue&type=template&id=79251e2e&"
import script from "./MajorDialog.vue?vue&type=script&lang=js&"
export * from "./MajorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports